var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1852 46.7604H15.7782C12.2707 46.7604 9.27349 45.5462 6.78661 43.118C4.29972 40.6897 3.05705 37.7217 3.0586 34.2142C3.0586 31.2077 3.96439 28.5289 5.77597 26.1777C7.58756 23.8265 9.95804 22.3233 12.8874 21.668C13.851 18.1219 15.7782 15.2504 18.6691 13.0534C21.5599 10.8563 24.8362 9.75781 28.4979 9.75781C33.0076 9.75781 36.8335 11.3289 39.9756 14.471C43.1177 17.6132 44.688 21.4383 44.6865 25.9464C47.3461 26.2548 49.5531 27.4019 51.3077 29.3877C53.0622 31.3735 53.9387 33.6954 53.9371 36.3534C53.9371 39.2442 52.925 41.7018 50.9006 43.7262C48.8763 45.7505 46.4195 46.7619 43.5302 46.7604H30.8105V30.2249L34.5108 33.8095L37.7485 30.5718L28.4979 21.3211L19.2472 30.5718L22.485 33.8095L26.1852 30.2249V46.7604Z",
    fill: "#766AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.b271800b4e10044be582e9c16bb77ea2.svg";
export { ForwardRef as ReactComponent };